export interface CardIssuer {
    id: string;
    name: string;
}

/**
 * Known card issuers (vendors) populated into the unified `credit_cards` and
 * `credit_card_transactions` tables. Shared between the Credit Cards and Unified
 * Credit Transactions pages so the vendor list only needs to be updated in one place.
 */
export const CardIssuers: CardIssuer[] = [
    { id: 'divvy', name: 'Divvy' },
    { id: 'privacy', name: 'Privacy.com' },
    { id: 'emburse', name: 'Emburse' },
];
